const ITEM_QUERY_KEY = "item";

export function getItemQueryKey(itemNo: string) {
  return [ITEM_QUERY_KEY, "info", itemNo];
}
